module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/2-3-2-15063d1c13be02662a711b9d5fe91842.png";